module.exports = __webpack_public_path__ + "img/menu-icon-close.c1d589f3.svg";